import * as React from 'react';
import SimpleButton from '../../../components/SimpleButton';
export const ClearButton = (props) => {
    return (React.createElement(SimpleButton, Object.assign({}, props, { className: "ab-StateManagement__Clear-Button", tooltip: "Clear User State" }), props.children));
};
